import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import keycloak from "../../hooks/keycloak";
interface usuario {
  sid: string;
  nombre: string;
  name: string;
  apellido_paterno: string;
  apellido_materno: string;
  email: string;
  telefono: string;
  tipo_usuario_id: number;
  platform: "";
  profile: string;
  area: string;
  rfc: null;
  aseguradora: string;
  no_cliente: string;
  username: string;
  fc_clave_asegurado: string;
  subscription_channel: string;
  numero_asegurado: string;
  fi_asignacion: number;
  fi_seleccion: number;
  fc_avatar: string;
  azp: string;
}
const usuarioVacio = {
  sid: null,
  nombre: "",
  name: "",
  apellido_paterno: "",
  apellido_materno: "",
  email: "",
  telefono: "",
  tipo_usuario_id: null,
  platform: null,
  profile: "",
  area: "",
  rfc: null,
  aseguradora: "",
  no_cliente: "",
  username: "",
  fc_clave_asegurado: "",
  subscription_channel: "",
  numero_asegurado: "",
  fi_asignacion: 0,
  fi_seleccion: 0,
  fc_avatar:
    "https://protec-amex.s3.amazonaws.com/amexprod/usuarios/5/avatar.jpeg",
  azp: "",
};

export interface UiState {
  token: string;
  usuario: any;
  etapaActual: number;
  fc_sub_etapa: string;
  valida: boolean;
  menu: boolean;
  fi_producto_seleccionado: number;
  isLoading: boolean;
  isAuthenticated: boolean;
  error: string;
  roles: string[];
}

const initialState: UiState = {
  token:

    typeof window !== "undefined"

      ? localStorage.getItem("app_token")

        ? localStorage.getItem("app_token")

        : ""

      : "",
  usuario: usuarioVacio,
  etapaActual: 0,
  fc_sub_etapa: "prueba",
  valida: true,
  menu: true,
  fi_producto_seleccionado: 0,
  isLoading: true,
  isAuthenticated: false,
  error: "",
  roles: [],
};
export const login = createAsyncThunk("auth/login", async () => {
  try {
    const authenticated = await keycloak.init({ onLoad: "login-required" });
    if (!authenticated) throw new Error("Authentication failed");
    return keycloak.token;
  } catch (error) {
    throw error;
  }
});

export const refreshToken = createAsyncThunk("auth/refreshToken", async () => {
  try {
    await keycloak.updateToken(70);
    return keycloak.token;
  } catch (error) {
    console.log("error");
    console.log(error);
    throw error;
  }
});

export const uiSlice = createSlice({
  initialState,
  name: "ui",
  reducers: {
    decrement: (state) => { },
    incrementByAmount: (state, action: PayloadAction<number>) => { },
    iniciarSesion: (state, action: PayloadAction<usuario>) => {
      state.usuario = action.payload;
      state.valida = false;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setUsuario: (state, action) => {
      state.usuario = action.payload;
      state.valida = false;
    },
    setRoles: (state, action) => {
      state.roles = action.payload;
    },
    agregarToken: (state, action: PayloadAction<any>) => {
      state.token = action.payload;
      state.isAuthenticated = true;
    },
    cambiarEtapa: (state, action: PayloadAction<any>) => {
      console.log("pruebaX", action.payload);
      state.etapaActual = action.payload.etapaActual;
      state.fc_sub_etapa = action.payload.fc_sub_etapa;
    },
    cambiaValida: (state, action: PayloadAction<number>) => {
      state.valida = true;
    },
    cerrarMenu: (state, action: PayloadAction<number>) => {
      state.menu = !state.menu;
    },
    agregarAvatar: (state, action: PayloadAction<string>) => {
      state.usuario.fc_avatar = action.payload;
    },
    cambiarProductoSeleccionado: (state, action: PayloadAction<number>) => {
      state.fi_producto_seleccionado = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.token = action.payload;
        state.usuario = keycloak.tokenParsed;
        state.isAuthenticated = true;
        state.isLoading = false;
      })
      .addCase(login.rejected, (state, action) => {
        state.error = action.error.message;
        state.isLoading = false;
      })
      .addCase(refreshToken.fulfilled, (state, action) => {
        console.log(action.payload);
        state.token = action.payload;
      });
  },
});

export const {
  iniciarSesion,
  cambiarEtapa,
  agregarToken,
  cambiaValida,
  cerrarMenu,
  agregarAvatar,
  cambiarProductoSeleccionado,
  setToken,
  setUsuario,
  setRoles,
} = uiSlice.actions;

export default uiSlice.reducer;
